import { StoreConfig, Store, akitaConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';

export interface UserInfo {
	id: string;
	name: string;
	email: string;
	firstName: string;
	productionCompanies: ProductionCompany[];
	role: Roles;
	selectedProductionCompany: 
	ProductionCompany & {logoUrl: string};
	
}
export interface ProductionCompany{
		id: string,
		name: string,
}
export enum Roles {
	STANDARD_USER = 'STANDARD',
	ADMIN = 'ADMIN',
	MANAGER = 'MANAGER',
	LEGAL_REPRESENTATIVE='LEGAL_REPRESENTATIVE'
}

export interface SessionState {
	isAuthenticated: boolean;
	userInfo: UserInfo;
	currentCompany: {id: string, name: string, logoUrl?:string} | null;
}

export function createInitialState(): SessionState {
	return {
		isAuthenticated: false,
		userInfo: null,
		currentCompany: null
	};
}

akitaConfig({
  resettable: true
})

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'sessionState' })
export class SessionStore extends Store<SessionState> {
	constructor() {
		super(createInitialState());
	}

	clearSession(): void {
		this._setState(state => createInitialState());
	}


}
